/**
 * A cake on the birthdays.
 *
 * Asked for by one of the testers, in Italian, for the word "compleanno". Doing
 * it only for that word would have made it a small delight for Italian and a
 * silence for everybody else — so it reads the word in all sixteen, and in the
 * forms people actually type: compleanni as well as compleanno, cumpleaños with
 * or without the ñ, bday as well as birthday.
 *
 * Stems rather than whole words, because these languages inflect: "complean"
 * catches compleanno and compleanni, "urodzin" catches urodziny and urodzinami.
 * Accents are stripped before matching, so somebody typing "cumpleanos" on a
 * keyboard without ñ gets their cake too.
 *
 * A wedding anniversary matches in Portuguese, French and Romanian, where the
 * same word covers both. That is not a bug worth fixing: a cake on an
 * anniversary is not wrong.
 *
 * Deliberately NOT matched: anything shorter than four letters. The Russian
 * "др" and the English "bd" would collide with ordinary words and put a cake on
 * a dentist appointment — and an emoji that turns up for no reason is worse
 * than one that never turns up at all.
 */
const STEMS = [
  'complean',      // it — compleanno, compleanni
  'birthday', 'bday', 'b-day', // en
  'cumplea',       // es — cumpleaños, cumple
  'geburtstag',    // de
  'anniversaire',  // fr
  'verjaardag',    // nl
  'aniversar',     // pt, ro — aniversário, aniversare
  'urodzin',       // pl
  'zi de nastere',  // ro
  '生日',           // zh, and inside the ja word too
  '誕生日',          // ja
  'जन्मदिन',         // hi
  '생일',            // ko
  'ميلاد',          // ar
  'день рожд',      // ru, as actually typed
];

/**
 * Fold a title down to something comparable: lower case, no accents.
 * Cyrillic, Arabic and the CJK scripts pass through untouched, which is what
 * we want — their stems are matched as written.
 */
function fold(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** True when this title is somebody's birthday. */
export function isBirthday(title) {
  if (!title) return false;
  const t = fold(title);
  return STEMS.some(stem => t.includes(fold(stem)));
}

export default isBirthday;
